/**
 * Utility functions for consistent Select component usage across the project
 */

// Default portal props for all react-select components
export const defaultSelectPortalProps = {
  classNamePrefix: "react-select",
  menuPortalTarget: document.body,
  menuPosition: "fixed",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: false,
  closeMenuOnScroll: false,
};

/**
 * Merges user props with default portal props to ensure consistent dropdown behavior
 * @param {Object} userProps - Props passed to the Select component
 * @returns {Object} Merged props with portal configuration
 */
export const getSelectProps = (userProps = {}) => ({
  ...defaultSelectPortalProps,
  ...userProps,
});

/**
 * Higher-order component that wraps react-select with portal props
 * @param {React.Component} SelectComponent - The Select component to wrap
 * @returns {React.Component} Enhanced Select component with portal props
 */
export const withPortalProps = (SelectComponent) => {
  return (props) => (
    <SelectComponent {...getSelectProps(props)} />
  );
};

/**
 * Applies portal props to an existing Select element props object
 * Use this when you can't modify the component directly
 * @param {Object} existingProps - Existing props object
 * @returns {Object} Enhanced props with portal configuration
 */
export const enhanceSelectProps = (existingProps) => 
  getSelectProps(existingProps);
